import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

interface MessageVipPublicHiddenView {
  vipDays: number
}

export const MessageVipPublicHiddenView: FC<MessageVipPublicHiddenView> = ({
  vipDays,
}) => (
  <FormattedMessage
    id="profile.vip.present.current.hidden.gift"
    defaultMessage="Подарен VIP-статус на {vipDays} дней."
    values={{
      vipDays,
    }}
  />
)
